// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/setting/setting.less
 ** module id = 29
 ** module chunks = 0
 **/